import React, { useState, useEffect } from "react";
import { Toast } from "@shopify/polaris";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { PROFILE } from "../../navigation/CONSTANTS";
import classes from "./Header.module.css";
import "./Header.css";
import logo from "../UI/assets/logo.svg";
import { jobstatusActions } from "../../store/jobstatus-slice";
import { getLocationSwitchRegenStatusAction } from "../../store/actions/job-actions";


const Header = (props) => {
  const dispatch = useDispatch();

  const history = useHistory();
  const { userDetails } = useSelector((state) => state.user);
  const {
    locationSwitchInProgress,
    locationSwitchFailed,
    locationSwitchFailedName,
  } = useSelector((state) => state.jobstatus);
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [userInitial, setUserInitial] = useState("");
  const [manualJobStatusCheck, setManualJobStatusCheck] = useState(null);


  
  const goTo = () => {
    history.push(`${PROFILE}`);
  };

  useEffect(() => {
    if (userDetails && userDetails.admin_name) {
      setUserInitial(userDetails.admin_name.charAt(0).toUpperCase());
    } else {
      setUserInitial("");
    }
  }, [userDetails]);
  useEffect(()=>{
    if(window.localStorage.getItem("manualJobStatusCheck")){
      return;
    }
    setManualJobStatusCheck(false)
  },[manualJobStatusCheck])

  /*
   * Mount-time restore of an in-flight location switch.
   *
   * The backend is the source of truth: if a switch's forecast is still regenerating
   * (status IN_PROGRESS), a full page reload should resume the loader + polling. We
   * make one status call on mount and, if inProgress, re-arm the switch in redux.
   */
  useEffect(() => {
    dispatch(getLocationSwitchRegenStatusAction()).then((data) => {
      if (data?.inProgress === true) {
        window.localStorage.setItem("locationSwitchCheck", "true");
        dispatch(jobstatusActions.startLocationSwitch({ name: null }));
      }
    });
    // Run once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*
   * Location-switch loader polling.
   *
   * While a location switch is in progress, poll the dedicated regen-status endpoint
   * on a short interval. The backend keeps that status IN_PROGRESS until the forecast
   * rows have actually finished regenerating, then flips it to SUCCESS/FAILED. The
   * reducer keeps the loader visible while inProgress is true and clears it (plus
   * flips ongoingJobStatus true->false to drive the refetch) once terminal.
   *
   * Header is always mounted, so this survives navigating between Settings and the
   * report. A max-timeout fallback force-clears the loader so it can never hang
   * forever if the switch job is deferred/retried (up to 20x over ~3min when
   * another bulk op is already running).
   */
  useEffect(() => {
    if (!locationSwitchInProgress) {
      return undefined;
    }

    // Poll immediately, then every 15s.
    dispatch(getLocationSwitchRegenStatusAction());
    const pollId = setInterval(() => {
      dispatch(getLocationSwitchRegenStatusAction());
    }, 15000);

    // Hard cap so the loader is never stuck (10 minutes). Accounts for slow regen
    // or deferred bulk retries. Tunable constant.
    const timeoutId = setTimeout(() => {
      window.localStorage.removeItem("locationSwitchCheck");
      dispatch(jobstatusActions.endLocationSwitch());
    }, 600000);

    return () => {
      clearInterval(pollId);
      clearTimeout(timeoutId);
    };
  }, [locationSwitchInProgress, dispatch]);

  // Clear the localStorage guard once the switch loader turns off.
  useEffect(() => {
    if (!locationSwitchInProgress) {
      window.localStorage.removeItem("locationSwitchCheck");
    }
  }, [locationSwitchInProgress]);


  // Error toast shown when a location switch ends in FAILED. Placed in the always-mounted
  // Header so it surfaces regardless of the current page, matching the loader's behavior.
  const locationSwitchFailureToast = locationSwitchFailed ? (
    <Toast
      content={`We couldn't finish switching to ${
        locationSwitchFailedName || "the selected location"
      }. Please try again.`}
      error
      onDismiss={() => dispatch(jobstatusActions.dismissLocationSwitchFailure())}
    />
  ) : null;

    return (
      <>
        {locationSwitchFailureToast}
        <div
          className="Polaris-Frame__TopBar"
          data-polaris-layer="true"
          data-polaris-top-bar="true"
          id="AppFrameTopBarMain"
        >
          <div
            className="Polaris-TopBar"
            style={{
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "#fff",
            }}
          >
            <div className="Polaris-TopBar__LogoContainer Polaris-TopBar__LogoDisplayControl">
              <span
                className="Polaris-TopBar__LogoLink logo_top_header"
                data-polaris-unstyled="true"
              >
                <img
                  src={logo}
                  alt="Forecasting V2"
                  className="Polaris-TopBar__Logo"
                />
              </span>
            </div>
            <div className={classes.PolarisTopBarContents}>
              <div
                className={`${classes.topBar_Search} Polaris-TopBar__SearchField`}
              >
                {/*
                  Progress bars live in OnboardingProgressBanner.
                  Header stays mounted only for location-switch polling
                  and the failure Toast.
                */}
              </div>
              <div className="Polaris-TopBar__SecondaryMenu"></div>
              {isLoggedIn === true ? (
                <>
                  <div className={classes.PolarisTopBarMenuActivatorWrapper}>
                    <button
                      style={{ backgroundColor: "#fff" }}
                      type="button"
                      className="Polaris-TopBar-Menu__Activator"
                      tabIndex="0"
                      aria-controls="Polarispopover3"
                      aria-owns="Polarispopover3"
                      aria-expanded="false"
                      onClick={() => goTo()}
                    >
                      <div className="Polaris-MessageIndicator__MessageIndicatorWrapper">
                        <span
                          aria-label=""
                          role="img"
                          className="Polaris-Avatar Polaris-Avatar--sizeSmall Polaris-Avatar--styleFour"
                        >
                          <span
                            style={{ fontSize: "20px" }}
                            className="Polaris-Avatar__Initials"
                          >
                            <svg
                              className="Polaris-Avatar__Svg"
                              viewBox="0 0 40 40"
                            >
                              <text
                                x="50%"
                                y="50%"
                                dy="0.35em"
                                fill="currentColor"
                                fontSize="20"
                                textAnchor="middle"
                              >
                                {userInitial}
                              </text>
                            </svg>
                          </span>
                        </span>
                      </div>
                      <span className="Polaris-TopBar-UserMenu__Details">
                        <p className="Polaris-TopBar-UserMenu__Name">
                          {userDetails ? (
                            <>
                              {userDetails?.admin_name?.length > 10
                                ? `${userDetails?.admin_name.slice(0, 10)}...`
                                : userDetails?.admin_name}
                            </>
                          ) : (
                            ""
                          )}
                        </p>
                        <p className="Polaris-TopBar-UserMenu__Detail"></p>
                      </span>
                    </button>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </>
    );
  
};

export default Header;
